import { render, staticRenderFns } from "./LvInfoArticle.vue?vue&type=template&id=31bd4252"
import script from "./LvInfoArticle.vue?vue&type=script&lang=js"
export * from "./LvInfoArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports